﻿var BASE_URL = '/api/AutoNotificationThresholds';

export interface SetRequest {
    Id: string; //: null for creation of a record.
    StationId: string;
    SensorId?: string;
    ParameterId?: string;
    MinutesThreshold: number;
}

export interface DeleteRequest {
    Id: string;
    StationId: string;
}

export interface EditResponse {
    Message: string;
    Errors: string[];
    AutoNotificationThreshold: AutoNotificationThreshold;
}

export interface TreeDataResponse {
    AllThresholds: AutoNotificationThreshold[];
    DefaultMinutesThreshold: number;
    TreeNodes: TreeDataNode[];
}

//: this is the expected keys received from server for TreeDataNode (to allow checking data integrity)
export const TreeDataNodeValidKeys: string[] = ["title", "expanded", "folder", "icon", "children", "NodeType", "RegionId", "RegionLabel", "StationId", "StationLabel", "SensorId", "SensorLabel", "ParameterId", "ParameterLabel", "AutoNotificationThreshold", "TreeNodeThresholdMinutes", "TreeNodeThresholdInheritFrom"];

export interface TreeDataNode extends Fancytree.NodeData {
    children?: TreeDataNode[] | undefined;
    NodeType: string;
    RegionId: string;
    RegionLabel: string;
    StationId?: string;
    StationLabel?: string;
    SensorId?: string;
    SensorLabel?: string;
    ParameterId?: string;
    ParameterLabel?: string;
    AutoNotificationThreshold?: AutoNotificationThreshold;
    TreeNodeThresholdMinutes: number;
    TreeNodeThresholdInheritFrom: string;
}

export function getAll(callback: (err: RESTError, data: AutoNotificationThreshold[]) => any): void {
    $.ajax(BASE_URL + '/Get/All', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: AutoNotificationThreshold[], text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function getTreeData(callback: (err: RESTError, data: TreeDataResponse) => any): void {
    $.ajax(BASE_URL + '/Get/TreeData', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 180000, //: NB: a bit longer as this can take a little time..
        success: (data: TreeDataResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function setSingle(data: SetRequest, callback: (err: RESTError, data: EditResponse, xhr: JQueryXHR) => any): void {
    $.ajax(BASE_URL + '/Set', {
        cache: false,
        type: 'POST',
        data: data,
        timeout: 30000,
        success: (data: EditResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data, jqXHR);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null, jqXHR);
        }
    });
}

export function deleteSingle(data: DeleteRequest, callback: (err: RESTError, data: EditResponse) => any): void {
    $.ajax(BASE_URL + '/Delete', {
        cache: false,
        type: 'POST',
        data: data,
        timeout: 30000,
        success: (data: EditResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}